import React, { useCallback, useMemo } from 'react';
import _get from 'lodash/get';

import { UiKit } from 'components';
import Content from './Content';
import { useMutation } from 'utils/hooks';

export default function ToggleExceptionModal({
  apiKey = '',
  isOpen = false,
  data = null,
  onClose = () => {},
  onClosed = () => {},
  successCallback = () => {},
  errorCallback = () => {}
}) {
  if (!apiKey) {
    throw new Error('"apiKey" is required in ToggleExceptionModal component');
  }

  const id = _get(data, 'id', '');
  const isActive = _get(data, 'is_active', false);

  const isModalOpen = isOpen && !!id;
  const isEnabling = !isActive;
  const buttonText = isEnabling ? 'Enable' : 'Disable';
  const buttonType = isEnabling ? 'primary' : 'destructive';

  const { mutate, isProcessing } = useMutation(apiKey, 'PATCH', {
    routeParam: id,
    payload: useMemo(() => ({ is_active: isEnabling }), [isEnabling]),
    successMessage: `Successfully ${buttonText.toLowerCase()}d the exception`,
    errorMessage: `Unable to ${buttonText.toLowerCase()} the exception at the moment. Please try again later.`,
    onSuccess: useCallback(() => successCallback(), [successCallback]),
    onError: useCallback(() => errorCallback(), [errorCallback]),
    onFinally: useCallback(() => onClose(), [onClose])
  });

  if (!id) return null;

  return (
    <UiKit.Modal
      isOpen={isModalOpen}
      onClose={onClose}
      onClosed={onClosed}
      isProcessing={isProcessing}
    >
      <UiKit.Modal.Header title={`${buttonText} Exception`} />
      <UiKit.Modal.Body>
        <Content data={data} />
      </UiKit.Modal.Body>
      <UiKit.Modal.Footer
        onConfirm={() => mutate()}
        confirmBtnVariant={buttonType}
        confirmBtnText={buttonText}
      />
    </UiKit.Modal>
  );
}
